import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";

const JobsLandingPage= ()=>{
    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };
    return(
        <div className={Style.businessPage}>
           <section className={Style.clear + " "+Style.breadcrumb}>
                <Container>
                <Row>
                    <Col>
                        <ul>
                            <li><Link to="/">Home </Link></li>
                            <li><Link to='/community'>Community</Link></li>
                            <li>Jobs</li>
                        </ul>
                    </Col>
                </Row>
                </Container>
            </section>
            <div className={Style.pageTitle + ' ' + Style.marginUp90}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Jobs</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className={Style.twoColSpace}>
                        <Col md={6}>
                            <div className={Style.communityContainer}>
                                <figure>
                                    <img src={require('../../../assest/images/community-img02.png')} />
                                </figure>
                                <div className={Style.communitelement}>
                                    <img src={require('../../../assest/images/business-listinr-icon01.png')} />
                                    <h3><Link to='/view-jobs-listing' >VIEW JOBS LISTING</Link></h3>
                                    <p>View Job Opening, Search & Apply For Jobs Posted By Mayo Alumni Communityy</p>
                                    <Link to='/view-jobs-listing' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className={Style.communityContainer}>
                                <figure>
                                    <img src={require('../../../assest/images/business-directory-img02.png')} />
                                </figure>
                                <div className={Style.communitelement}>
                                    <img src={require('../../../assest/images/business-listinr-icon02.png')} />
                                    <h3><Link to='/myjobs'>POST JOB OPENING</Link></h3>
                                    <p>Submit Job Opening In Your Organisation For Listing In The Job Listings Directory</p>
                                    <Link to='/myjobs' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default JobsLandingPage;